<template>
    <modal name="JoinerModal"
           @before-open="beforeOpen"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :max-width="600"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto"
           width="50%"
           :scrollable="true"
           classes="popupcontainer"
    >
        <div class="popupcontainer vue-dialog">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    신청 상세
                </h4>
            </div>

            <div style="margin-left: 20px;" class="modal-body">
                <div class="row">
                    <div class="col-4">
                        이름
                    </div>
                    <div class="col-8">
                        {{article.memberName}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        신청 상태
                    </div>
                    <div class="col-8">
                        {{convertState(article.status)}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        신청일
                    </div>
                    <div class="col-8">
                        {{$root.$children[0].dateFormat(article.createdDate,'YYYY.MM.DD HH:mm')}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        수정일
                    </div>
                    <div class="col-8">
                        <span v-if="article.createdDate == article.modifiedDate">
                            -
                        </span>
                        <span v-else>
                            {{$root.$children[0].dateFormat(article.modifiedDate,'YYYY.MM.DD HH:mm')}}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        메모
                    </div>
                    <div class="col-8">
                        {{article.description}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        참여요일
                    </div>
                    <div class="col-8">
                        {{article.isRepeatableMon ? '월' : ''}}
                        {{article.isRepeatableTue ? '화' : ''}}
                        {{article.isRepeatableWed ? '수' : ''}}
                        {{article.isRepeatableThu ? '목' : ''}}
                        {{article.isRepeatableFri ? '금' : ''}}
                        {{article.isRepeatableSat ? '토' : ''}}
                        {{article.isRepeatableSun ? '일' : ''}}
                    </div>
                </div>
                <div class="row" v-if="false">
                    <div class="col-4">
                        도시락 신청 여부
                    </div>
                    <div class="col-8">
                        {{convertLunch(article.isAppliedLunchbox)}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        교통수단
                    </div>
                    <div class="col-8">
                        {{article.transportation}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        매주 봉사 숙지
                    </div>
                    <div class="col-8">
                        {{convertConfirm(article.isConfirmDayOfWeek)}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        봉사장소
                    </div>
                    <div class="col-8">
                        {{convertPalce(article.volunteerPlace)}}
                    </div>
                </div>
            </div>
            <div class="vue-dialog-buttons">
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="close()">닫기</button>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "JoinerModal",
        data() {
            return {
                article : {},
                statusMap: {},
            }
        },
        methods: {
            close() {
                this.$modal.hide('JoinerModal')
            },
            beforeOpen (event) {
                this.article = event.params.article;
            },
            convertState(state){
                switch(state){
                    case "APPROVED" : return "활동승인";
                    case "COMPLETED" : return "참여완료";
                    case "NOSHOW" : return "불참";
                    case "PAID" : return "결제완료";
                    case "REJECTED" : return "반려";
                    case "REQUESTED" : return "신청대기";
                    case "WAITING" : return "결제대기";
                    default : break;

                }
            },
            convertLunch(isAppliedLunchbox){
                if(isAppliedLunchbox == true){
                    return "신청";
                }else if(isAppliedLunchbox == false){
                    return "미신청"
                }else{
                    return "해당없음";
                }

            },
            convertConfirm(isConfirmDayOfWeek){
                if(isConfirmDayOfWeek == true){
                    return "예";
                }else if(isConfirmDayOfWeek == false){
                    return "아니오"
                }else{
                    return "미선택";
                }
            },
            convertPalce(place){
                switch (place) {
                    case "1f" : return "1층 견사"; break;
                    case "2f" : return "2층 견사"; break;
                    case "cat" : return "묘사"; break;
                    case "lobby" : return "로비"; break;
                    case "other" : return "기타"; break;
                    default : return "기타"; break;
                }
            }

            // getStatusMap() {
            //     let me = this;
            //     let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/member/status`;
            //     //console.log(u);
            //     this.axios.get(url)
            //         .then(function (res) {
            //             me.statusMap = res.data;
            //         }).catch(function (error) {
            //         console.log(error);
            //     });
            // },
        },
        mounted() {
            // this.getStatusMap();
        },
        created() {
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        z-index: 1050;
        max-height: 70%;
    }

    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        border-top: 1px solid #EEE;
        padding: 1em;
        text-align: center;
    }

    .row{
        margin-bottom: 1rem;
    }
    .col-8{
        font-weight: 600;
        font-size: 17px;
    }

</style>